import styled from 'styled-components';

const CurrencyBar = styled.div`
  margin-top: ${(props): string => props.theme.spaces.lg};
  margin-bottom: ${(props): string => props.theme.spaces.lg};
  display: flex;

  > div:first-child {
    width: 22rem;
  }

  > button {
    margin-left: auto;
    align-self: flex-end;
  }
`;

export { CurrencyBar };
